import React from 'react';
import { downloadOrganizingCampsInstructionDocumentAction } from '../../../../../../services/request';
import { WorkStandardsGeneric } from './generics/WorkStandardsGeneric';

export const OrganizingCampsInstructionDocuments = () => (
  <WorkStandardsGeneric
    downloadDocumentAction={downloadOrganizingCampsInstructionDocumentAction}
    serializerFieldName="organizing_camps_instruction_documents"
    title="Instrukcje organizacji obozów"
    showChecked={false} />
);
